import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// ── Wizard Layout ──────────────────────────────────────────
export var wizardContainer = function wizardContainer(theme) {
  return {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    backgroundColor: theme.gray50
  };
};
export var wizardHeader = function wizardHeader(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1.6rem 2.4rem',
    borderBottom: "1px solid ".concat(theme.gray100),
    backgroundColor: theme.white,
    '& .wizard-title': {
      fontSize: '1.8rem',
      fontWeight: 600,
      color: theme.gray800
    },
    '& .wizard-back': {
      display: 'flex',
      alignItems: 'center',
      gap: '0.4em',
      color: theme.gray500,
      cursor: 'pointer',
      fontSize: '1.3rem',
      transition: 'color 0.15s ease',
      '&:hover': {
        color: theme.primary
      }
    }
  };
};
export var wizardBody = {
  display: 'flex',
  flex: 1,
  overflow: 'hidden',
  '@media (max-width: 992px)': {
    flexDirection: 'column'
  }
};
export var wizardMain = {
  flex: 1,
  overflow: 'auto',
  padding: '2rem 2.4rem',
  minWidth: 0,
  '@media (max-width: 992px)': {
    padding: '1.6rem'
  }
};
export var wizardSidebar = function wizardSidebar(theme) {
  return {
    width: 320,
    flexShrink: 0,
    overflow: 'auto',
    borderLeft: "1px solid ".concat(theme.gray100),
    backgroundColor: theme.white,
    padding: '2rem 1.6rem',
    '@media (max-width: 992px)': {
      width: '100%',
      borderLeft: 'none',
      borderTop: "1px solid ".concat(theme.gray100),
      padding: '1.6rem',
      maxHeight: 300
    }
  };
}; // ── Step Progress ──────────────────────────────────────────

export var stepperContainer = function stepperContainer(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1.6rem 2.4rem',
    backgroundColor: theme.white,
    borderBottom: "1px solid ".concat(theme.gray100),
    gap: 0,
    overflowX: 'auto',
    '@media (max-width: 786px)': {
      padding: '1.2rem 1rem'
    }
  };
};
export var stepItem = function stepItem(isActive, isCompleted) {
  return function (theme) {
    return {
      display: 'flex',
      alignItems: 'center',
      gap: '0.6em',
      whiteSpace: 'nowrap',
      cursor: isCompleted ? 'pointer' : 'default',
      '& .step-circle': _objectSpread({
        width: '2.8rem',
        height: '2.8rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.2rem',
        fontWeight: 600,
        flexShrink: 0,
        transition: 'all 0.2s ease'
      }, isActive ? {
        backgroundColor: theme.primary,
        color: theme.mode === 'dark' ? theme.gray800 : theme.white
      } : isCompleted ? {
        backgroundColor: theme.successLight,
        color: theme.success
      } : {
        backgroundColor: theme.gray100,
        color: theme.gray400
      }),
      '& .step-label': {
        fontSize: '1.2rem',
        fontWeight: isActive ? 600 : 400,
        color: isActive ? theme.gray800 : isCompleted ? theme.gray600 : theme.gray400,
        transition: 'color 0.2s ease',
        '@media (max-width: 786px)': {
          display: 'none'
        }
      }
    };
  };
};
export var stepConnector = function stepConnector(isCompleted) {
  return function (theme) {
    return {
      width: '3rem',
      height: 2,
      margin: '0 0.6em',
      flexShrink: 0,
      backgroundColor: isCompleted ? theme.success : theme.gray200,
      transition: 'background-color 0.3s ease',
      '@media (max-width: 786px)': {
        width: '1.5rem',
        margin: '0 0.3em'
      }
    };
  };
}; // ── Sidebar Cards ──────────────────────────────────────────

export var sidebarCard = function sidebarCard(theme) {
  return {
    marginBottom: '1.6rem',
    '& .sidebar-card-title': {
      fontSize: '1.1rem',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      color: theme.gray400,
      marginBottom: '1rem'
    }
  };
};
export var sidebarItem = function sidebarItem(theme) {
  return {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.6em 0',
    borderBottom: "1px solid ".concat(theme.gray100),
    fontSize: '1.3rem',
    '&:last-child': {
      borderBottom: 'none'
    },
    '& .sidebar-label': {
      color: theme.gray500
    },
    '& .sidebar-value': {
      color: theme.gray800,
      fontWeight: 500,
      textAlign: 'right'
    }
  };
};
export var sidebarBorrowerName = function sidebarBorrowerName(theme) {
  return {
    fontSize: '1.5rem',
    fontWeight: 600,
    color: theme.gray800,
    marginBottom: '0.8rem'
  };
}; // ── Wizard Footer ──────────────────────────────────────────

export var wizardFooter = function wizardFooter(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1.2rem 2.4rem',
    borderTop: "1px solid ".concat(theme.gray100),
    backgroundColor: theme.white,
    '@media (max-width: 786px)': {
      padding: '1rem 1.6rem'
    }
  };
};